import { Pipe, type PipeTransform } from '@angular/core';
import { ApprovalState } from '@fdm/api-client';

@Pipe({
  name: 'appApprovalState',
})
export class ApprovalStatePipe implements PipeTransform {
  transform(value: ApprovalState | string): string {
    switch (value) {
      case ApprovalState.Draft:
        return 'Draft';
      case ApprovalState.DraftedForReview:
        return 'Drafted for Review';
      case ApprovalState.SubmittedToOpsAdvisor:
        return 'Submitted to OpsAdvisor';
      case ApprovalState.PlanConfirmed:
        return 'Plan Confirmed';
      case ApprovalState.RIPTScored:
        return 'RIPT Scored';
      case ApprovalState.RiskEvaluationScored:
        return 'Risk Scored';
      // case ApprovalState.RIPTSkipped:
      //   return 'RIPT Skipped';
      case ApprovalState.PlanEndorsed:
        return 'Plan Endorsed';
      case ApprovalState.PlanApproved:
        return 'Plan Approved';
      case ApprovalState.ResolutionPlanCompleted:
        return 'Resolution Plan Completed';
      case ApprovalState.ValidationAndVerificationCompleted:
        return 'V&V Completed';
      case ApprovalState.Closed:
        return 'Closed';
      case ApprovalState.Cancelled:
        return 'Cancelled';
      case ApprovalState.OutOfService:
        return 'Out of Service';
      case 'Initiating':
        return 'Initiating';
      case 'PlanCreationAndApproving':
        return 'Plan Creation & Approving';
      case 'Implementing':
        return 'Implementing';
      case 'Completing':
        return 'Completing';
      case 'Recycle':
        return 'Recycle';
      default:
        return '-';
      // case ApprovalState.Cancelled:
      // case ApprovalState.OutOfService:
    }
  }
}
